import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import epiasLogo from "../../assets/img/epias-logo.svg";
import yekgLogo from "../../assets/img/yekg-logo.svg";
import moment from "moment";
import { API_EXPORT } from "../../helpers/api";
import fileDownload from "js-file-download";
import { setNotification } from "../../helpers/notification";
import Button from "../../components/Button";

export default function Result(props) {
  const redemptionDetail = useSelector((state) => state.portal.redemptionData);

  const translationsTR = {
    1: "Ocak",
    2: "Şubat",
    3: "Mart",
    4: "Nisan",
    5: "Mayıs",
    6: "Haziran",
    7: "Temmuz",
    8: "Ağustos",
    9: "Eylül",
    10: "Ekim",
    11: "Kasım",
    12: "Aralık",
    BIOMASS: "Biyokütle",
    WIND: "Rüzgar",
    HYDROPOWER: "Hidroelektrik",
    GEOTHERMAL: "Jeotermal",
    SOLAR: "Güneş",
    IFSA_YESIL_TARIFE: "İfşa (Yeşil Tarife)",
    IFSA: "İfşa",
    CONSUMER: "Son Tüketici",
    PRODUCER: "Tedarikçi",
    ALUMINIUM: "Alüminyum",
    MALL_SUPER_MARKET: "AVM & Süpermarket",
    BANKING_FINANCE: "Bankacılık & Finans",
    EDUCATION: "Eğitim",
    ELECTRICAL_ELECTRONIC: "Elektrik & Elektronik",
    ENERGY: "Enerji",
    FOOD_INDUSTRY: "Gıda",
    CONSTRUCTION: "İnşaat",
    COSMETIC: "Kozmetik",
    MACHINE_CHEMISTRY_OIL: "Makine & Kimya & Petrol",
    RESIDENTIAL: "Mesken",
    METAL_MINING: "Metal & Madencilik",
    OFFICE: "Ofis",
    AUTOMOTIVE: "Otomotiv",
    HEALTH_SOCIAL_SERVICES: "Sağlık & Sosyal Hizmetler",
    INDUSTRY: "Sanayi & Endüstri",
    AGRICULTURE_LIVESTOCK: "Tarım & Hayvancılık",
    TECHNOLOGY_WHITE_GOODS: "Teknoloji & Beyaz Eşya",
    TEXTILE: "Tekstil",
    TELECOMMUNICATION: "Telekomünikasyon",
    TOURISM_HOTEL_MANAGEMENT: "Turizm & Otelcilik",
    TRANSPORTATION_LOGISTICS: "Ulaştırma & Lojistik",
    OTHER: "Diğer",
  };
  const translationsEN = {
    1: "January",
    2: "February",
    3: "March",
    4: "April",
    5: "May",
    6: "June",
    7: "July",
    8: "August",
    9: "September",
    10: "October",
    11: "November",
    12: "December",
    BIOMASS: "Biomass",
    WIND: "Wind",
    HYDROPOWER: "Hydropower",
    GEOTHERMAL: "Geotermal",
    SOLAR: "Solar",
    IFSA_YESIL_TARIFE: "Disclosure (Green Tariff)",
    IFSA: "Disclosure",
    CONSUMER: "End Consumer",
    PRODUCER: "Producer",
    AGRICULTURE_LIVESTOCK: "Agriculture & Livestock",
    ALUMINIUM: "Aluminium",
    AUTOMOTIVE: "Automotive",
    BANKING_FINANCE: "Banking & Finance",
    CONSTRUCTION: "Construction",
    COSMETIC: "Cosmetic",
    EDUCATION: "Education",
    ELECTRICAL_ELECTRONIC: "Electrical & Electronic",
    ENERGY: "Energy",
    FOOD_INDUSTRY: "Food Industry",
    HEALTH_SOCIAL_SERVICES: "Health & Social Services",
    INDUSTRY: "Industry",
    MACHINE_CHEMISTRY_OIL: "Machine & Chemistry & Oil",
    MALL_SUPER_MARKET: "Mall & Super Market",
    METAL_MINING: "Metal & Mining",
    OFFICE: "Office",
    RESIDENTIAL: "Residential",
    TECHNOLOGY_WHITE_GOODS: "Technology & White Goods",
    TELECOMMUNICATION: "Telecommunication",
    TEXTILE: "Textile",
    TOURISM_HOTEL_MANAGEMENT: "Tourism & Hotel Management",
    TRANSPORTATION_LOGISTICS: "Transportation & Logistics",
    OTHER: "Other",
  };
  const techTypeTR = {
    1: "Arıtma Çamuru ve Kavaleto - Fermantasyon",
    2: "Atık Isı",
    3: "Atık Kağıtların İşlenmesi Sonucu Elde Edilen Prolitik Gaz ve Prolitik Yağ",
    4: "Atık Lastik - Biyokütle (Prolitik Sıvı) Yakıtlı",
    5: "Atık Lastiklerin İşlenmesi Sonucu Ortaya Çıkan Yan Ürünler",
    6: "Atık Su Arıtma",
    7: "Belediye Atıkları - Biyometanizasyon",
    8: "Belediye Atıkları - Çöp Gazı",
    9: "Bitkisel Atık",
    10: "Bitkisel Atık - Fermantasyon",
    11: "Bitkisel Atık - Hayvansal Atık",
    12: "Bitkisel Atık - Hayvansal Atık - Biyometanizasyon",
    13: "Bitkisel Atık - Hayvansal Atık - Enerji Bitkisi - Biyometanizasyon",
    14: "Bitkisel Atık - Hayvansal Atık - Fermantasyon",
    15: "Bitkisel Atık - Orman Atığı",
    16: "Bitkisel Atık - Orman Atığı - Doğrudan Yakma",
    17: "Bitkisel Yağ Atıkları - Ağır Biyoyakıtlı Motor",
    18: "Biyogaz",
    19: "Biyokütle",
    20: "Çöp Gazı",
    21: "Çöp Gazı - Arıtma Çamuru - Katı Atık",
    22: "Çöp Gazı - Fermantasyon",
    23: "Çöp Gazı (Metan)",
    24: "Doğal Gaz",
    25: "Doğrudan Yakma - Hayvansal ve Tarımsal Atık",
    26: "Endüstriyel Atık - Doğrudan Yakma",
    27: "Enerji Bitkisi - Biyometanizasyon",
    28: "Evsel Atık",
    29: "Evsel Atık (Çöp Gazı)",
    30: "Fotovoltaik",
    31: "Hayvansal Atık",
    32: "Hayvansal Atık -  Bitkisel Atık - Enerji Bitkisi",
    33: "Hayvansal Atık - Bitkisel Atık - Fermantasyon",
    34: "Hayvansal Atık - Biyogaz",
    35: "Hayvansal Atık - Biyometanizasyon",
    36: "Hayvansal Atık - Fermantasyon",
    37: "Hayvansal Atık - Gazlaştırma",
    38: "Hayvansal Atık - Tarımsal Atık",
    39: "Hayvansal ve Bitkisel Atık",
    40: "Hayvansal ve Bitkisel Atık - Biyometanizasyon",
    41: "Hayvansal ve Bitkisel Atık - Fermantasyon",
    42: "Hayvansal ve Tarımsal Atık",
    43: "Hayvansal ve Tarımsal Atık - Biyometanizasyon",
    44: "Hayvansal,Bitkisel ve Organik Atıklar- Biyometanizasyon",
    45: "Jeotermal",
    46: "Kanal Tipi",
    47: "Kentsel Atık",
    48: "Kentsel Atık - Biyometanizasyon",
    49: "Kentsel Atık - Çöp Gazı",
    50: "Kentsel Atık - Doğrudan Yakma",
    51: "Kentsel Atık - Doğrudan Yakma - Biyometanizasyon",
    52: "Kentsel Atık - Fermantasyon",
    53: "Kentsel Atık - Gazlaştırma - Biyometanizasyon",
    54: "Kentsel Atıklar, Tarımsal ve Orman Atıkları İle Atık Lastiklerin İşlenmesi Sonucu Oluşan Yan Ürünler",
    55: "LNG - Siyah Likör - Biyokütle",
    56: "Odun Kabuğu, Siyah Likör Yakıtlı",
    57: "Orman Atığı",
    58: "Orman Atığı - Bitkisel Atık",
    59: "Orman Atığı - Doğrudan Yakma",
    60: "Orman Atığı - Gazlaştırma",
    61: "Orman Atığı - Tarımsal Atık",
    62: "Orman Atığı, Arıtma Çamuru - Doğrudan Yakma",
    63: "Orman Atığı, Bitkisel, Hayvansal ve Endüstriyel Atık - Doğrudan Yakma",
    64: "Orman Yan Ürünü",
    65: "Peynir Altı Suyu - Biyometanizasyon",
    66: "Prolitik Yağ",
    67: "Proses Atık Isısı",
    68: "Rezervuarlı",
    69: "Rezervuarli + Kanal Tipi",
    70: "Rüzgar",
    71: "Tarım ve Ormancılık Kaynaklı Atıklar",
    72: "Tarımsal Atık ve Orman Atığı - Doğrudan Yakma",
    73: "Tarımsal Atık, Hayvansal Atık ve Orman Atığı",
    74: "Tarımsal Hasat Artığı",
    75: "Tarımsal ve Hayvansal Atık",
    76: "Tarımsal ve Ormansal Atık",
    77: "Tarımsal, Hayvansal ve Arıtma Çamuru",
    78: "Yerli Asfaltit",
  };
  const techTypeEN = {
    1: "Purification Sludge and Kavaleto - Fermentation",
    2: "Waste Heat",
    3: "Pyrolytic Gas and Pyrolytic Oil Obtained as a Result of Processing Waste Papers",
    4: "Waste Tire - Biomass (Prolytic Liquid) Fueled",
    5: "By-Products Arising As A Result Of The Processing Of Waste Tires",
    6: "Purification of wastewater",
    7: "Municipal Waste - Biomethanization",
    8: "Municipal Waste - Landfill Gas",
    9: "Herbal Waste",
    10: "Herbal Waste - Fermentation",
    11: "Herbal Waste - Animal Waste",
    12: "Herbal Waste - Animal Waste - Biomethanization",
    13: "Herbal Waste - Animal Waste - Energy Plant - Biomethanization",
    14: "Herbal Waste - Animal Waste - Energy Plant - Biomethanization",
    15: "Herbal Waste - Animal Waste - Fermentation",
    16: "Herbal Waste - Forest Waste - Direct Incineration",
    17: "Plant Oil Waste - Heavy Biofuel Engine",
    18: "Biogas",
    19: "Biomass",
    20: "Landfill Gas",
    21: "Landfill Gas - Treatment Sludge - Solid Waste",
    22: "Landfill Gas - Fermentation",
    23: "Landfill Gas (Methane)",
    24: "Natural gas",
    25: "Direct Incineration - Animal and Agricultural Waste",
    26: "Industrial Waste - Direct Incineration",
    27: "Energy Plant - Biomethanization",
    28: "Domestic Waste",
    29: "Domestic Waste (Landfill Gas)",
    30: "Photovoltaic",
    31: "Animal Waste",
    32: "Animal Waste - Herbal Waste - Energy Plant",
    33: "Animal Waste - Herbal Waste - Fermentation",
    34: "Animal Waste - Biogas",
    35: "Animal Waste - Biomethanization",
    36: "Animal Waste - Fermentation",
    37: "Animal Waste - Gasification",
    38: "Animal Waste - Agricultural Waste",
    39: "Animal and Vegetable Waste",
    40: "Animal and Vegetable Waste - Biomethanization",
    41: "Animal and Vegetable Waste - Fermentation",
    42: "Animal and Agricultural Waste",
    43: "Animal and Agricultural Waste - Biomethanization",
    44: "Animal, Herbal and Organic Wastes - Biomethanization",
    45: "Geothermal",
    46: "Channel Type",
    47: "Urban Waste",
    48: "Urban Waste - Biomethanization",
    49: "Urban Waste - Landfill Gas",
    50: "Urban Waste - Direct Incineration",
    51: "Urban Waste - Direct Incineration - Biomethanization",
    52: "Urban Waste - Fermentation",
    53: "Urban Waste - Gasification - Biomethanization",
    54: "Urban Wastes, Agricultural and Forest Wastes and By-Products as a Result of the Processing of Waste Tires",
    55: "LNG - Black Liquor - Biomass",
    56: "Wood Bark, Black Liquor",
    57: "Forest Waste",
    58: "Forest Waste - Herbal Waste",
    59: "Forest Waste - Direct Incineration",
    60: "Forest Waste - Gasification",
    61: "Forest Waste - Agricultural Waste",
    62: "Forest Waste, Treatment Sludge - Direct Incineration",
    63: "Forest Waste, Vegetable, Animal and Industrial Waste - Direct Incineration",
    64: "Forest By-Product",
    65: "Whey - Biomethanization",
    66: "Prolytic Oil",
    67: "Process Waste Heat",
    68: "Reservoir",
    69: "Reservoir + Channel Type",
    70: "Wind",
    71: "Agriculture and Forest Waste",
    72: "Agricultural Waste and Forest Waste - Direct Incineration",
    73: "Agricultural Waste, Animal Waste and Forest Waste",
    74: "Agricultural Harvest Surplus",
    75: "Agricultural and Animal Waste",
    76: "Agricultural and Forestry Waste",
    77: "Agricultural, Animal and Treatment Sludge",
    78: "Domestic Asphaltite",
  };
  useEffect(() => {
    if (!redemptionDetail.id) {
      props.history.push("/portal");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const downloadRedemptionCertificate = async (row) => {
    try {
      const res = await API_EXPORT(
        `redemption/export/pdf/${redemptionDetail.id}`
      );
      fileDownload(res.data, "cancellation-certificates.pdf");
      setNotification("success", "PDF Dosyası Başarıyla İndirildi.");
    } catch (err) {
      err.response && setNotification("error", err.response.data.message);
    }
  };

  return redemptionDetail.id ? (
    <div className="km__c--redemption-detail-page">
      <div className="km__c--redemption-detail-page-header">
        <img src={yekgLogo} alt="" />
      </div>
      <div className="km__c--redemption-detail-page-body">
        <div className="km__c--modal-redemption-title-divider">
          İtfa Detayları
          <span className="km__c--modal-certificate-english">
            / Cancellation Details
          </span>
        </div>
        <div className="km__c--modal-redemption-details-half-width">
          <div>
            <span>
              İşlem Türü
              <span className="km__c--modal-certificate-english">
                / Transaction Type:
              </span>
            </span>
            <p>İtfa</p>
          </div>
          <div>
            <span>
              İtfa Tarihi
              <span className="km__c--modal-certificate-english">
                / Cancellation Date:
              </span>
            </span>
            <p>
              {moment(redemptionDetail.redemptionDate).format(
                "DD/MM/YYYY HH:mm:ss"
              )}
            </p>
          </div>
          <div>
            <span>
              İtfa Numarası
              <span className="km__c--modal-certificate-english">
                / Cancellation No:
              </span>
            </span>
            <p>{redemptionDetail.id}</p>
          </div>
          <div>
            <span>
              İtfa Durumu
              <span className="km__c--modal-certificate-english">
                / Cancellation Status:
              </span>
            </span>
            <p>
              Tamamlandı
              <span className="km__c--modal-certificate-english">
                / Completed
              </span>
            </p>
          </div>
        </div>
        <div className="km__c--modal-redemption-details-row">
          <div className="km__c--modal-redemption-details-half-width">
            <div>
              <span>
                Organizasyon Adı
                <span className="km__c--modal-certificate-english">
                  / Organization Name:
                </span>
              </span>
              <p>{redemptionDetail.organizationName}</p>
            </div>
            <div>
              <span>
                Organizasyon Hesap Numarası
                <span className="km__c--modal-certificate-english">
                  / Organization Account No:
                </span>
              </span>
              <p>{redemptionDetail.organizationId}</p>
            </div>
            <div>
              <span>
                Organizasyon Adresi
                <span className="km__c--modal-certificate-english">
                  / Organization Address:
                </span>
              </span>
              <p>{redemptionDetail.organizationAddress}</p>
            </div>
            <div>
              <span>
                Ülke
                <span className="km__c--modal-certificate-english">
                  / Country:
                </span>
              </span>
              <p>{redemptionDetail.organizationCountry}</p>
            </div>
          </div>
          <div className="km__c--modal-redemption-details-half-width">
            <div>
              <span>
                Yararlanıcı Taraf Adı
                <span className="km__c--modal-certificate-english">
                  / Beneficiary Name:
                </span>
              </span>
              <p>{redemptionDetail.beneficiaryParty.title}</p>
            </div>
            <div>
              <span>
                Yararlanıcı Taraf Türü
                <span className="km__c--modal-certificate-english">
                  / Beneficiary Type:
                </span>
              </span>
              <p>
                {
                  translationsTR[
                    redemptionDetail.beneficiaryParty.beneficiaryPartyType
                  ]
                }
                <span className="km__c--modal-certificate-english">
                  /{" "}
                  {
                    translationsEN[
                      redemptionDetail.beneficiaryParty.beneficiaryPartyType
                    ]
                  }
                </span>
              </p>
            </div>
            <div>
              <span>
                Vergi Numarası - TC Kimlik Numarası
                <span className="km__c--modal-certificate-english">
                  / Tax ID - Identity No:
                </span>
              </span>
              <p>{redemptionDetail.beneficiaryParty.taxOrIdentityNumber}</p>
            </div>
            <div>
              {console.log(
                "redemptionDetail?.beneficiaryParty?.sector: ",
                redemptionDetail?.beneficiaryParty?.sector
              )}
              <span>
                Sektör
                <span className="km__c--modal-certificate-english">
                  / Sector:
                </span>
              </span>
              {redemptionDetail?.beneficiaryParty?.sector ? (
                <p>
                  {translationsTR[redemptionDetail.beneficiaryParty.sector]}
                  <span className="km__c--modal-certificate-english">
                    / {translationsEN[redemptionDetail.beneficiaryParty.sector]}
                  </span>
                </p>
              ) : (
                "-"
              )}
            </div>
            <div>
              <span>
                Adres
                <span className="km__c--modal-certificate-english">
                  / Address:
                </span>
              </span>
              <p className="km__c--modal-certificate-english-avoid-overflow">
                {redemptionDetail?.beneficiaryParty?.address}{" "}
                {redemptionDetail?.beneficiaryParty?.district}{" "}
                {redemptionDetail?.beneficiaryParty?.city ? (
                  <span>
                    /{" "}
                    {redemptionDetail?.beneficiaryParty?.city?.toLocaleUpperCase(
                      "tr-TR"
                    )}
                  </span>
                ) : null}
              </p>
            </div>
            <div>
              <span>
                İtfa Amacı
                <span className="km__c--modal-certificate-english">
                  / Cancellation Purpose:
                </span>
              </span>
              <p>
                {
                  translationsTR[
                    redemptionDetail.beneficiaryParty.redemptionPurpose
                  ]
                }
                <span className="km__c--modal-certificate-english">
                  /{" "}
                  {
                    translationsEN[
                      redemptionDetail.beneficiaryParty.redemptionPurpose
                    ]
                  }
                </span>
              </p>
            </div>
            <div>
              <span>
                Tüketim Dönemi
                <span className="km__c--modal-certificate-english">
                  / Consumption Period:
                </span>
              </span>
              <p>
                {
                  translationsTR[
                    moment(
                      redemptionDetail.beneficiaryParty.consumptionStartTerm
                    ).format("M")
                  ]
                }{" "}
                {moment(
                  redemptionDetail.beneficiaryParty.consumptionStartTerm
                ).format("YYYY")}{" "}
                -{" "}
                {
                  translationsTR[
                    moment(
                      redemptionDetail.beneficiaryParty.consumptionEndTerm
                    ).format("M")
                  ]
                }{" "}
                {moment(
                  redemptionDetail.beneficiaryParty.consumptionEndTerm
                ).format("YYYY")}
                <span className="km__c--modal-certificate-english">
                  /{" "}
                  {
                    translationsEN[
                      moment(
                        redemptionDetail.beneficiaryParty.consumptionStartTerm
                      ).format("M")
                    ]
                  }{" "}
                  {moment(
                    redemptionDetail.beneficiaryParty.consumptionStartTerm
                  ).format("YYYY")}{" "}
                  -{" "}
                  {
                    translationsEN[
                      moment(
                        redemptionDetail.beneficiaryParty.consumptionEndTerm
                      ).format("M")
                    ]
                  }{" "}
                  {moment(
                    redemptionDetail.beneficiaryParty.consumptionEndTerm
                  ).format("YYYY")}
                </span>
              </p>
            </div>
            <div>
              <span>
                Açıklama
                <span className="km__c--modal-certificate-english">
                  / Description:
                </span>
              </span>
              <p className="km__c--modal-certificate-english-avoid-overflow">
                {redemptionDetail.description}
              </p>
            </div>
          </div>
        </div>
        <div className="km__c--modal-redemption-title-divider">
          İhraç Edilen YEK-G Belgelerinin Detayları
          <span className="km__c--modal-certificate-english">
            / Details of Issued YEK-G Certificate
          </span>
        </div>
        <div className="km__c--modal-redemption-certificate-header">
          <div className="km__c--modal-redemption-certificate-quantity">
            Toplam Miktar (MWh)
            <span className="km__c--modal-certificate-english">
              / Total Amount (MWh):
            </span>
            <span>
              {redemptionDetail.redemptionDetails.reduce((acc, value) => {
                acc += value.amount;
                return acc;
              }, 0)}
            </span>
          </div>
          <div className="km__c--modal-redemption-certificate-quantity">
            {redemptionDetail.beneficiaryParty.beneficiaryPartyType ===
            "PRODUCER"
              ? "Toplam Tüketim Miktarı"
              : "Toplam YEK-G Belgesi Miktarı"}
            <span className="km__c--modal-certificate-english">
              /{" "}
              {redemptionDetail.beneficiaryParty.beneficiaryPartyType ===
              "PRODUCER"
                ? "Total Consumption Amount:"
                : "Total Amount of YEK-G Certificates:"}
            </span>
            <span>
              {redemptionDetail.redemptionDetails.reduce((acc, value) => {
                acc += value.amount;
                return acc;
              }, 0)}
            </span>
          </div>
        </div>
        <div className="km__c--modal-redemption-certificate-table">
          <table>
            <thead>
              <tr>
                <th>
                  Belge Numarası
                  <span className="km__c--modal-certificate-english">
                    / Document No
                  </span>
                </th>
                <th>
                  Miktar
                  <span className="km__c--modal-certificate-english">
                    / Amount
                  </span>
                </th>
                <th>
                  Kaynak Tipi
                  <span className="km__c--modal-certificate-english">
                    / Resource Type
                  </span>
                </th>
                <th>
                  Üretim Tesisi
                  <span className="km__c--modal-certificate-english">
                    / Production Facility
                  </span>
                </th>
                <th>
                  Üretim Dönemi
                  <span className="km__c--modal-certificate-english">
                    / Production Period
                  </span>
                </th>
                <th>
                  İhraç Dönemi
                  <span className="km__c--modal-certificate-english">
                    / Issue Period
                  </span>
                </th>
                <th>
                  İhraç Tarihi
                  <span className="km__c--modal-certificate-english">
                    / Issuance Date
                  </span>
                </th>
                <th>
                  Sistem Adı
                  <span className="km__c--modal-certificate-english">
                    / System Name
                  </span>
                </th>
              </tr>
            </thead>
            <tbody>
              {redemptionDetail.redemptionDetails.map((item) => {
                return (
                  <tr
                    key={`${item.yekgCertificateDto.documentStartNo}-${item.yekgCertificateDto.documentEndNo}`}
                  >
                    <td>
                      {item.yekgCertificateDto.documentStartNo}-
                      {item.yekgCertificateDto.documentEndNo}
                    </td>
                    <td>{item.amount}</td>
                    <td>
                      {translationsTR[item.yekgCertificateDto.resourceType]}
                      <span className="km__c--modal-certificate-english">
                        / {translationsEN[item.yekgCertificateDto.resourceType]}
                      </span>
                    </td>
                    <td>
                      {
                        item.yekgCertificateDto.productionData.station
                          .stationName
                      }
                    </td>
                    <td>
                      {
                        translationsTR[
                          moment(
                            item.yekgCertificateDto.productionData.term
                          ).format("M")
                        ]
                      }{" "}
                      {moment(
                        item.yekgCertificateDto.productionData.term
                      ).format("YYYY")}
                      <span className="km__c--modal-certificate-english">
                        /{" "}
                        {
                          translationsEN[
                            moment(
                              item.yekgCertificateDto.productionData.term
                            ).format("M")
                          ]
                        }{" "}
                        {moment(
                          item.yekgCertificateDto.productionData.term
                        ).format("YYYY")}
                      </span>
                    </td>
                    <td>
                      {
                        translationsTR[
                          moment(item.yekgCertificateDto.exportDate).format("M")
                        ]
                      }{" "}
                      {moment(item.yekgCertificateDto.exportDate).format(
                        "YYYY"
                      )}
                      <span className="km__c--modal-certificate-english">
                        /{" "}
                        {
                          translationsEN[
                            moment(item.yekgCertificateDto.exportDate).format(
                              "M"
                            )
                          ]
                        }{" "}
                        {moment(item.yekgCertificateDto.exportDate).format(
                          "YYYY"
                        )}
                      </span>
                    </td>
                    <td>
                      {moment(item.yekgCertificateDto.exportDate).format(
                        "DD.MM.YYYY HH:mm:ss"
                      )}
                    </td>
                    <td>YEK-G</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
        <div className="km__c--modal-redemption-title-divider">
          Organizasyon ve Üretim Tesisi Detayları
          <span className="km__c--modal-certificate-english">
            / Details of Organization Production Facility
          </span>
        </div>
        <div className="km__c--modal-redemption-certificate-table">
          <table>
            <thead>
              <tr>
                <th>
                  Organizasyon Adı
                  <span className="km__c--modal-certificate-english">
                    / Organization Name
                  </span>
                </th>
                <th>
                  Organizasyon Etso Kod
                  <span className="km__c--modal-certificate-english">
                    / Etso Code of Organization
                  </span>
                </th>
                <th>
                  Üretim Tesisi Lisans Numarası
                  <span className="km__c--modal-certificate-english">
                    / Licence Number of Production Facility
                  </span>
                </th>
                <th>
                  Üretim Tesisi Adı
                  <span className="km__c--modal-certificate-english">
                    / Production Facility Name
                  </span>
                </th>
                <th>
                  Üretim Tesisi Konumu
                  <span className="km__c--modal-certificate-english">
                    / Production Facility Location
                  </span>
                </th>
                <th>
                  Üretim Tesisi İşletmedeki Güç (MWh)
                  <span className="km__c--modal-certificate-english">
                    / Installed Power of Production Facility (MWh)
                  </span>
                </th>
                <th>
                  Üretim Tesisi Kaynak Tipi
                  <span className="km__c--modal-certificate-english">
                    / Production Facility Resource Type
                  </span>
                </th>
                <th>
                  Üretim Tesisi Teknoloji Tipi
                  <span className="km__c--modal-certificate-english">
                    / Production Facility Technology Type
                  </span>
                </th>
                <th>
                  Üretim Tesisi Yardımcı Kaynak Tipi
                  <span className="km__c--modal-certificate-english">
                    / Production Facility Subsidiary Resource Type
                  </span>
                </th>
                <th>
                  Üretim Tesisi İşletmeye Alınma Tarihi
                  <span className="km__c--modal-certificate-english">
                    / Production Facility Commissioning Date
                  </span>
                </th>
                <th>
                  Destekleme Mekanizması
                  <span className="km__c--modal-certificate-english">
                    / Supporting Mechanism
                  </span>
                </th>
              </tr>
            </thead>
            <tbody>
              {redemptionDetail.redemptionDetails.map((item) => {
                return (
                  <tr
                    key={
                      item.yekgCertificateDto.productionData.station.stationId
                    }
                  >
                    <td>
                      {
                        item.yekgCertificateDto.productionData.organization
                          .organizationName
                      }
                    </td>
                    <td>
                      {
                        item.yekgCertificateDto.productionData.organization
                          .etsoCode
                      }
                    </td>
                    <td>
                      {
                        item.yekgCertificateDto.productionData.station
                          .stationLicenseNo
                      }
                    </td>
                    <td>
                      {
                        item.yekgCertificateDto.productionData.station
                          .stationName
                      }
                    </td>
                    <td>
                      {
                        item.yekgCertificateDto.productionData.station
                          .stationDistrict
                      }{" "}
                      -{" "}
                      {
                        item.yekgCertificateDto.productionData.station
                          .stationCity
                      }
                    </td>
                    <td>
                      {
                        item.yekgCertificateDto.productionData.station
                          .operatingPower
                      }
                    </td>
                    <td>
                      {
                        translationsTR[
                          item.yekgCertificateDto.productionData.station
                            .resourceType
                        ]
                      }{" "}
                      <span className="km__c--modal-certificate-english">
                        /{" "}
                        {
                          translationsEN[
                            item.yekgCertificateDto.productionData.station
                              .resourceType
                          ]
                        }
                      </span>
                    </td>
                    <td>
                      {item.yekgCertificateDto.productionData.station
                        .stationTechType ? (
                        <>
                          {
                            techTypeTR[
                              item.yekgCertificateDto.productionData.station
                                .stationTechType
                            ]
                          }{" "}
                          <span className="km__c--modal-certificate-english">
                            /{" "}
                            {
                              techTypeEN[
                                item.yekgCertificateDto.productionData.station
                                  .stationTechType
                              ]
                            }
                          </span>
                        </>
                      ) : (
                        "-"
                      )}
                    </td>
                    <td>
                      {item.yekgCertificateDto.productionData.station
                        .hybridResourceType ? (
                        <>
                          {
                            translationsTR[
                              item.yekgCertificateDto.productionData.station
                                .hybridResourceType
                            ]
                          }{" "}
                          <span className="km__c--modal-certificate-english">
                            /{" "}
                            {
                              translationsEN[
                                item.yekgCertificateDto.productionData.station
                                  .hybridResourceType
                              ]
                            }
                          </span>
                        </>
                      ) : (
                        "-"
                      )}
                    </td>
                    <td>
                      {item.yekgCertificateDto.productionData.station
                        .productionStartDate
                        ? moment(
                            item.yekgCertificateDto.productionData.station
                              .productionStartDate
                          ).format("DD.MM.YYYY")
                        : "-"}
                    </td>
                    <td>
                      {item.yekgCertificateDto.productionData.station
                        .yekdemStatus
                        ? "YEKDEM"
                        : "-"}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
        <div className="text-box text-justify">
          <p className="km__c--modal-redemption-info-text">
            İşbu İtfa belgesi, içerdiği YEK-G belgelerinin Piyasa işletmecisi
            olan EPİAŞ tarafından itfa edildiğini tasdik etmektedir. İtfa
            belgesinde yer alan YEK-G belgeleriyle ilişkilendirilen
            yenilenebilir elektriğin çevresel nitelikleri yararlanıcı tarafından
            ilgili tüketim döneminde tüketilmiştir. İtfa belgesinde yer alan
            YEK-G belgeleri devredilemez ve söz konusu YEK-G belgelerinin başka
            bir tedarikçiye ve/veya son tüketiciye itfası mümkün değildir. Bu
            itfa belgesinin kopyalanması, değiştirilmesi ve ileriye dönük satışı
            yasaktır.
          </p>
          <p className="km__c--modal-redemption-info-text">
            This cancellation statement document confirms that YEK-G documents
            subjected to the cancellation statement have been cancelled by
            EXIST, the Market Operator. The environmental qualities of the
            associated renewable energy included in the cancellation statement
            document have been consumed by the beneficiary party in the relevant
            consumption period. YEK-G documents included in the cancellation
            statement are not transferable and the cancellation of the relevant
            YEK-G documents to another supplier and/or end consumer is
            prohibited. Any later sale or cancellation or this cancellation
            statement is forbidden. It is forbidden to copy or amend this
            cancellation statement as well.
          </p>
        </div>
      </div>

      <div className="km__c--redemption-detail-page-footer">
        <img src={epiasLogo} alt="" />
        <div className="fixed-button">
          <Button
            type="secondary"
            onClick={downloadRedemptionCertificate}
            label="İndir / Download"
            suffixIcon="download"
          />
        </div>
      </div>
    </div>
  ) : (
    ""
  );
}
